import React from "react";
import { useState } from "react";
// import CvvInfo from "./cvvInfo";
import { Autocomplete, Box, Button, Radio, TextField } from "@mui/material";
import { useFirstTheme, usePaymentLink } from "./page";

import axixbankIcon from "../assets/axisbank.svg";
import hdfcbankIcon from "../assets/hdfcbank.svg";
import icicibankIcon from "../assets/icicibank.svg";
import kotakbankIcon from "../assets/kotakbank.svg";
import sbibankIcon from "../assets/sbibank.svg";
import phonepayIcon from "../assets/phonepay.svg";
import paytmIcon from "../assets/paytm.svg";
import bhimIcon from "../assets/bhimlogo.svg";
import gpayIcon from "../assets/gpaylogo.svg";
import addmoreIcon from "../assets/addmore.svg";
import paylaterIcon from "../assets/paylater.svg";
// import LazyPayIcon from "../assets/LazyPay.svg";
// import simplIcon from "../assets/getsimplIcon.svg";
import upiAnimatedIcon from "../assets/upiAnimated3.svg";
import creditDebitIcon from "../assets/creditDebit3.svg";
import payLaterIcon from "../assets/payLater3.svg";
import netBankingIcon from "../assets/netBanking3.svg";
import crossArrowIcon from "../assets/crossArrow.svg";
// import informationIcon from "../assets/information.svg";
import phonepayTheme2 from "../assets/phonepayTheme2.svg";
import paytmTheme2 from "../assets/paytmTheme2.svg";
import bhimTheme2 from "../assets/bhimTheme2.svg";
import gpayTheme2 from "../assets/gpayTheme2.svg";
import UPITheme2 from "../assets/UPITheme2.svg";
import creditcardTheme2 from "../assets/creditcardTheme2.svg";
import WalletTheme2 from "../assets/WalletTheme2.svg";
import NetbankingTheme2 from "../assets/NetbankingTheme2.svg";
import { useFirstModule } from "../provider/invoiceProvider";
import { SplitByNum, removeWhiteSpace } from "../utils/splitByNum";
import bandhanBankSvg from "../assets/bandhanbanks.svg";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PaymentIcon from "@mui/icons-material/Payment";

import axixbankSvg from "../assets/axisbank.svg";
import hdfcbankSvg from "../assets/hdfcbank.svg";
import icicibankSvg from "../assets/icicibank.svg";
import kotakbankSvg from "../assets/kotakbank.svg";
import sbibankSvg from "../assets/sbibank.svg";
import Popup from "../components/popup";
import { isMobile } from "react-device-detect";
import { initiateInvoiceTransaction } from "../services/initiateInvoiceTransaction";

interface CountryType {
  code: string;
  label: string;
  img?: string;
}

interface CardDataType {
  txn_mode: "DC" | "CC";
  card_number: string;
  card_holder_name: string;
  card_cvv: string;
  card_expiry_date: string;
}

interface CardDataTypeError {
  txn_mode?: string;
  card_number?: string;
  card_holder_name?: string;
  card_cvv?: string;
  card_expiry_date?: string;
}

const SecondPaymentType = () => {
  const [upi, setUpi] = useState(true);
  const [openCard, setOpenCard] = useState(false);
  const [payLater, setPayLater] = useState(false);
  const [isNetBanking, setNetBanking] = useState(false);
  const [selectedType, setSelectedType] = useState("UPI");
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { invoiceLink, updateTheme } = useFirstTheme();
  const { linkData, updatePaymentLink } = usePaymentLink();
  const [trigger, setTrigger] = React.useState(false);
  const { invoiceData } = useFirstModule();
  // const [showCvvInfo, setCvvInfo] = React.useState(false);

  const [htmlContent, setHtmlContent] = React.useState<string>("");
  const [isPopupOpen, setIsPopupOpen] = React.useState<boolean>(false);
  const [cardData, setCardData] = React.useState<CardDataType>({
    txn_mode: "DC",
    card_number: "",
    card_holder_name: "",
    card_cvv: "",
    card_expiry_date: "",
  });

  const [cardDataError, setCardDataError] = React.useState<CardDataTypeError>({
    txn_mode: "",
    card_number: "",
    card_holder_name: "",
    card_cvv: "",
    card_expiry_date: "",
  });
  const [selectedBank, setSelectedBank] = React.useState("");

  const fetchHtmlContent = async () => {
    if (validateCardData(cardData)) {
      openPopup();
      try {
        const response = await fetch(
          "https://backend.vaamozdevelop.xyz/VampayLiveApi/EasebuzzDebitPayment",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Origin: "https://vaamoz.com",
            },
            body: JSON.stringify({
              ...cardData,
              amount: invoiceData?.payable_amount,
            }),
          },
        );
        const html = await response.text();
        setHtmlContent(html);
      } catch (error) {
        console.error("Error fetching HTML:", error);
      }
    }
  };

  const handleCardChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;
    if (name === "card_number") {
      value = removeWhiteSpace(value);
    }
    setCardData({ ...cardData, [name]: value });
  };

  const handleCardTypeChange = () => {
    const cardType = cardData?.txn_mode === "DC" ? "CC" : "DC";

    setCardData({ ...cardData, txn_mode: cardType });
  };

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const netBankingArray = [
    {
      name: "Axis Bank",
      icon: axixbankIcon,
      value: "",
    },
    {
      name: "HDFC Bank",
      icon: hdfcbankIcon,
      value: "",
    },
    {
      name: "ICICI Bank",
      icon: icicibankIcon,
      value: "",
    },
    {
      name: "Kotak Bank",
      icon: kotakbankIcon,
      value: "",
    },
    {
      name: "SBI Bank",
      icon: sbibankIcon,
      value: "",
    },
  ];

  const payLaterArray = [
    {
      name: "ICICI Pay later",
      icon: paylaterIcon,
      value: "",
    },
    {
      name: "Lazypay",
      icon: paylaterIcon,
      value: "",
    },
    {
      name: "Lazypay",
      icon: paylaterIcon,
      value: "",
    },
  ];

  const paymentType = [
    {
      id: 1,
      name: "UPI",
      link: "",
      image: UPITheme2,
    },
    {
      id: 2,
      name: "Credit/Debit",
      link: "",
      image: creditcardTheme2,
    },
    {
      id: 3,
      name: "Pay Later",
      link: "",
      image: WalletTheme2,
    },
    {
      id: 4,
      name: "Net Banking",
      link: "",
      image: NetbankingTheme2,
    },
  ];

  const UpiType = [
    {
      id: 1,
      name: "UPI",
      link: "",
      image: phonepayTheme2,
      appName: "phonepe",
    },
    {
      id: 2,
      name: "Credit/Debit",
      link: "",
      image: paytmTheme2,
      appName: "paytm",
    },
    {
      id: 3,
      name: "Pay Later",
      link: "",
      image: bhimTheme2,
      appName: "bhim",
    },
    {
      id: 4,
      name: "Net Banking",
      link: "",
      image: gpayTheme2,
      appName: "gpay",
    },
  ];

  const redirectToPaymentApp = async (selectedGateway: string) => {
    let dataLink = invoiceLink?.link;
    if (!trigger) {
      const data = await initiateInvoiceTransaction(invoiceData);
      // console.log(trigger, "-<><><>>>>>>----->");
      updateTheme({
        link: data?.link,
        order_id: data?.order_id,
      });

      dataLink = data?.link;
      setTrigger(true);
    }

    let paymentLink;
    switch (selectedGateway) {
      case "gpay":
        // window.location.href = `googlepay://upi/transaction?pa=${encodeURIComponent(
        //   paymentLink
        // )}`;
        paymentLink = dataLink?.replace("upi://", "tez://upi/");
        updatePaymentLink({
          link: paymentLink,
          app: "gpay",
          upiId: "",
        });
        break;
      case "phonepe":
        // window.location.href = `phonepe://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "phonepe://");
        updatePaymentLink({
          link: paymentLink,
          app: "phonepe",
          upiId: "",
        });
        break;
      case "paytm":
        // window.location.href = `paytm://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "paytmmp://");
        updatePaymentLink({
          link: paymentLink,
          app: "paytm",
          upiId: "",
        });
        break;
      case "bhim":
        // window.location.href = `bhim://upi/transaction?pa=${encodeURIComponent(
        //   invoiceLink?.link
        // )}`;
        paymentLink = dataLink?.replace("upi://", "upi://pay?");
        updatePaymentLink({
          link: paymentLink,
          app: "bhim",
          upiId: "",
        });
        break;

      // case "addmore":
      //   // window.location.href = `bhim://upi/transaction?pa=${encodeURIComponent(
      //   //   invoiceLink?.link
      //   // )}`;
      //   paymentLink = invoiceLink?.link;
      //   updatePaymentLink({
      //     link: paymentLink,
      //     app: "addmore",
      //   });
      //   break;
      default:
        console.error("Unsupported payment gateway");
    }
  };

  const handleNetBanking = () => {
    setNetBanking(!isNetBanking);
  };

  const netBankingType: readonly CountryType[] = [
    { code: "AXB", label: "Axis Bank ", img: axixbankSvg },
    {
      code: "BANB",
      label: "Bandhan Bank",
      img: bandhanBankSvg,
    },
    { code: "HDFCB", label: "HDFC Bank", img: hdfcbankSvg },
    {
      code: "ICICIB",
      label: "ICICI Bank",
      img: icicibankSvg,
    },
    {
      code: "SBOI",
      label: "State Bank of India",
      img: sbibankSvg,
    },
  ];

  const validateCardData = (data: CardDataType) => {
    const ErrorObj: CardDataTypeError = {};
    let isValid = true;

    const checkNumber = /^\d+$/;
    const checkExpiry = /^(0[1-9]|1[0-2])\/\d{2}$/;
    const checkNameValidity = /^[A-Za-z\s]+$/;

    if (data?.card_number === "" && !checkNumber.test(data?.card_number)) {
      ErrorObj.card_number = "Kindly Enter a Valid Card Number";
      isValid = false;
    }
    // if (data?.amount === "" && !checkNumber.test(data?.amount)) {
    //   ErrorObj.amount = "Kindly Enter a Valid Payable Amount";
    //   isValid = false;
    // }

    if (data?.card_cvv === "" && !checkNumber.test(data?.card_cvv)) {
      ErrorObj.card_cvv = "Kindly Enter a Valid CVV";
      isValid = false;
    }

    if (
      data?.card_expiry_date === "" &&
      !checkExpiry.test(data?.card_expiry_date)
    ) {
      ErrorObj.card_expiry_date = "Kindly Enter a Valid Expiry Date";
      isValid = false;
    }

    if (
      data?.card_holder_name === "" &&
      !checkNameValidity.test(data?.card_holder_name)
    ) {
      ErrorObj.card_holder_name = "Kindly Enter a Valid Name";
      isValid = false;
    }

    setCardDataError({
      ...cardDataError,
      ...ErrorObj,
    });
    return isValid;
  };

  const handleNetBankingSubmit = async () => {
    openPopup();
    try {
      const response = await fetch(
        "https://backend.vaamozdevelop.xyz/VampayLiveApi/EasebuzzNetBanking",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Origin: "https://vaamoz.com",
          },
          body: JSON.stringify({
            amount: invoiceData?.payable_amount,
            bank: selectedBank,
          }),
        },
      );
      const html = await response.text();

      setHtmlContent(html);
    } catch (error) {
      console.error("Error fetching HTML:", error);
    }
  };

  const handleSelectionChange = (event: React.SyntheticEvent, value: any) => {
    value?.code && setSelectedBank(value?.code);
  };

  return (
    <div>
      <div>
        <div className=" my-2 flex flex-wrap gap-2 ">
          {paymentType.map((item, index) => (
            <button
              key={item?.id}
              onClick={() => {
                updatePaymentLink({
                  link: "",
                  app: "",
                  upiId: "",
                });
                setSelectedType(item.name);
              }}
              className={`h-[10vh]  ${
                selectedType === item.name
                  ? "bg-[#E5E5E5] border-white "
                  : "bg-[#FFFFFF] border-[#E5E5E5] "
              }  text-[12px] flex flex-[45%] flex-col justify-center items-center border-2 rounded-2xl`}
            >
              <img
                src={item.image}
                alt={"type"}
                width={50}
                height={50}
                className="object-none"
              />
              <p>{item.name}</p>
            </button>
          ))}
        </div>
      </div>
      {selectedType == "UPI" && (
        <div className="flex gap-2 justify-between items-center">
          {UpiType.map((item, index) => (
            <button
              key={item?.id}
              onClick={() => redirectToPaymentApp(item.appName)}
              className={`h-[6vh] w-1/4 p-2 flex  justify-center items-center border-2  ${
                linkData?.app === item.appName
                  ? "bg-[#FFFFFF}] border-white "
                  : "bg-white border-[#E5E5E5]"
              } rounded-xl`}
            >
              <img
                src={item.image}
                alt={"type"}
                width={80}
                height={50}
                className="object-contain"
              />
            </button>
          ))}
        </div>
      )}
      {selectedType == "Credit/Debit" && (
        // <div className="flex gap-3 flex-wrap p-6 bg-white rounded-xl">
        //   <div className=" w-full flex justify-between items-center border rounded-md p-2">
        //     <input
        //       placeholder="Card Number"
        //       className="w-full  bg-transparent outline-none"
        //     />
        //     {/* <img
        //         src={"/tag.svg"}
        //         alt="logo"
        //         height={30}
        //         width={30}
        //         className="ml-2"
        //       /> */}
        //   </div>
        //   <input
        //     placeholder="Name on card"
        //     className="w-full p-2 rounded-md bg-transparent border outline-none"
        //   />
        //   <div className="flex gap-3">
        //     <input
        //       placeholder="Valid Thru (MM/YY)"
        //       className="w-2/3 p-2 rounded-md bg-transparent border outline-none"
        //     />
        //     <div className=" w-1/3 flex justify-between items-center border rounded-md p-2">
        //       <input
        //         placeholder="CVV"
        //         className="rounded-md bg-transparent  overflow-x-hidden outline-none"
        //       />
        //       <button onClick={handleClick}>
        //         {/* <img
        //           src={informationIcon}
        //           alt="logo"
        //           height={30}
        //           width={30}
        //           className="ml-1"
        //         /> */}
        //       </button>
        //     </div>
        //   </div>
        // </div>

        <div className="flex gap-3 flex-wrap p-4 bg-[#F5F5F5]">
          <Button
            variant="outlined"
            endIcon={<ArrowDropDownIcon />}
            startIcon={
              cardData?.txn_mode === "DC" ? <PaymentIcon /> : <CreditCardIcon />
            }
            fullWidth
            onClick={handleCardTypeChange}
          >
            {cardData?.txn_mode === "DC" ? "Debit Card" : "Credit Card"}
          </Button>
          <div
            className={`flex items-center justify-between w-full p-2 border rounded-md ${
              cardDataError?.card_number ? "border-red-500" : ""
            }`}
          >
            <input
              // type="number"
              name="card_number"
              placeholder="Card Number"
              className={`w-full bg-transparent outline-none `}
              value={SplitByNum(cardData?.card_number)}
              // value={cardData?.card_number}
              onChange={handleCardChange}
            />
          </div>
          <p className="text-red-600">{cardDataError?.card_number}</p>

          <input
            name="card_holder_name"
            placeholder="Name on card"
            className={`w-full p-2 bg-transparent border rounded-md outline-none ${
              cardDataError?.card_holder_name ? "border-red-500" : ""
            }`}
            value={cardData?.card_holder_name}
            onChange={handleCardChange}
          />
          <p className="text-red-600">{cardDataError?.card_holder_name}</p>
          <div className="flex gap-3 w-full">
            <input
              name="card_expiry_date"
              placeholder="Valid Thru (MM/YY)"
              className={`w-2/3 p-2 bg-transparent border rounded-md outline-none ${
                cardDataError?.card_expiry_date ? "border-red-500" : ""
              }`}
              value={cardData?.card_expiry_date}
              onChange={handleCardChange}
            />
            <div
              className={`flex items-center justify-between w-1/3 p-2 border rounded-md ${
                cardDataError?.card_cvv ? "border border-red-500" : ""
              }`}
            >
              <input
                type="number"
                name="card_cvv"
                placeholder="CVV"
                className={`overflow-x-hidden w-full bg-transparent rounded-md outline-none `}
                value={cardData?.card_cvv}
                onChange={handleCardChange}
              />
              {/* <button onClick={handleClick}>
                    <img
                      src={info}
                      alt="logo"
                      height={30}
                      width={30}
                      className="ml-2"
                    />
                  </button> */}
            </div>
          </div>
          <p className="text-red-600">{cardDataError?.card_cvv}</p>
          <p className="text-red-600">{cardDataError?.card_expiry_date}</p>
          <Button
            variant="contained"
            onClick={fetchHtmlContent}
            fullWidth
            disabled={invoiceData?.payable_amount === ""}
          >
            Submit
          </Button>
        </div>
      )}
      {selectedType == "Pay Later" && (
        <div className="bg-white rounded-2xl flex flex-col px-2">
          {payLaterArray.map((item, index) => (
            <div
              key={index}
              className="flex justify-between p-4 items-center border-dashed border-b"
            >
              <div className="flex items-center gap-4">
                <img src={item.icon} alt="." height={40} width={40} />
                <p>{item.name}</p>
              </div>
              <div>
                {/* <img src={item.icon} alt="." height={40} width={40} />
                 */}
                <Radio
                  checked={false}
                  // onChange={handleChange}
                  value="b"
                  name="radio-buttons"
                  inputProps={{ "aria-label": "B" }}
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 25,
                      background: "white",
                      borderRadius: 10,
                    },
                    margin: 0,
                    padding: 0,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {selectedType == "Net Banking" && (
        // <div className="bg-white flex flex-col rounded-2xl px-2">
        //   {netBankingArray.map((item, index) => (
        //     <div
        //       key={index}
        //       className="flex justify-between p-4 items-center border-dashed border-b"
        //     >
        //       <div className="flex items-center gap-4">
        //         <img src={item.icon} alt="." height={40} width={40} />
        //         <p>{item.name}</p>
        //       </div>
        //       <div>
        //         <Radio
        //           checked={false}
        //           // onChange={handleChange}
        //           value="b"
        //           name="radio-buttons"
        //           inputProps={{ "aria-label": "B" }}
        //           sx={{
        //             "& .MuiSvgIcon-root": {
        //               fontSize: 25,
        //               background: "white",
        //               borderRadius: 10,
        //             },
        //             margin: 0,
        //             padding: 0,
        //           }}
        //         />
        //       </div>
        //     </div>
        //   ))}
        // </div>
        <div className="bg-[#F5F5F5] flex flex-col px-2 p-2 gap-4">
          {/* {netBankingArray.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 border-b border-dashed"
                >
                  <div className="flex items-center gap-4">
                    <img src={item.icon} alt="." height={40} width={40} />
                    <p>{item.name}</p>
                  </div>
                </div>
              ))} */}
          <Autocomplete
            fullWidth
            id="country-select-demo"
            options={netBankingType}
            autoHighlight
            getOptionLabel={(option) => option.label}
            onChange={handleSelectionChange}
            renderOption={(props, option) => {
              const { ...optionProps } = props;
              return (
                <Box
                  // key={key}
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...optionProps}
                >
                  <img loading="lazy" width="20" src={option?.img} alt="" />
                  {option.label}
                </Box>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Choose a Bank"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password",
                }}
              />
            )}
          />
          <Button
            variant="contained"
            onClick={handleNetBankingSubmit}
            disabled={
              !(
                invoiceData?.payable_amount !== "" &&
                selectedBank !== "" &&
                Number(invoiceData?.payable_amount) > 0
              )
            }
          >
            Submit
          </Button>
        </div>
      )}
      {/* <CvvInfo
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        handleClick={handleClick}
        handleClose={handleClose}
      /> */}
      <Popup
        htmlContent={htmlContent}
        onClose={closePopup}
        isOpen={isPopupOpen}
      />
    </div>
  );
};

export default SecondPaymentType;
